package com.daytimegaming.ourdailyfinances.data.network.service

import com.daytimegaming.ourdailyfinances.data.network.ApiClient
import com.daytimegaming.ourdailyfinances.data.network.dto.AccountDto
import com.daytimegaming.ourdailyfinances.data.network.dto.AccountListResponse
import com.daytimegaming.ourdailyfinances.data.network.dto.UpdateAccountNicknameRequest
import com.daytimegaming.ourdailyfinances.data.network.dto.LinkExchangeRequest
import com.daytimegaming.ourdailyfinances.data.network.dto.LinkExchangeResponse
import com.daytimegaming.ourdailyfinances.data.network.dto.LinkTokenResponse
import com.daytimegaming.ourdailyfinances.data.network.dto.PlaidItemsResponse
import com.daytimegaming.ourdailyfinances.data.network.dto.TransactionsResponse
import com.daytimegaming.ourdailyfinances.data.network.dto.MessageResponse
import com.daytimegaming.ourdailyfinances.data.network.dto.RecurringTransactionsResponse
import com.daytimegaming.ourdailyfinances.data.network.dto.TransactionDto
import com.daytimegaming.ourdailyfinances.data.network.dto.UpdateCategoryRequest
import com.daytimegaming.ourdailyfinances.data.network.dto.PortfolioHistoryResponse
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.patch
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.client.request.parameter
import com.daytimegaming.ourdailyfinances.data.network.dto.SecurityPerformanceResponse
import com.daytimegaming.ourdailyfinances.data.network.dto.PlaidPricesSyncResponse

class AccountService(private val apiClient: ApiClient) {
    suspend fun getAccounts(): AccountListResponse =
        apiClient.http.get("${apiClient.baseUrl}/plaid/balance").body()

    suspend fun createLinkToken(): LinkTokenResponse =
        apiClient.http.post("${apiClient.baseUrl}/plaid/link/token").body()

    suspend fun createUpdateLinkToken(itemId: String): LinkTokenResponse =
        apiClient.http.post("${apiClient.baseUrl}/plaid/items/$itemId/update-link-token").body()

    suspend fun createConsentUpdateLinkToken(itemId: String): LinkTokenResponse =
        apiClient.http.post("${apiClient.baseUrl}/plaid/items/$itemId/consent-update-link-token").body()

    suspend fun exchangePublicToken(publicToken: String, institutionName: String?): LinkExchangeResponse =
        apiClient.http.post("${apiClient.baseUrl}/plaid/link/exchange") {
            contentType(ContentType.Application.Json)
            setBody(LinkExchangeRequest(publicToken, institutionName))
        }.body()

    suspend fun getPlaidItems(): PlaidItemsResponse =
        apiClient.http.get("${apiClient.baseUrl}/plaid/items").body()

    suspend fun unlinkItem(itemId: String): MessageResponse =
        apiClient.http.delete("${apiClient.baseUrl}/plaid/items/$itemId").body()

    suspend fun getTransactions(): TransactionsResponse =
        apiClient.http.get("${apiClient.baseUrl}/plaid/transactions").body()

    suspend fun getRecurringTransactions(): RecurringTransactionsResponse =
        apiClient.http.get("${apiClient.baseUrl}/plaid/recurring-transactions").body()

    suspend fun updateTransactionCategory(transactionId: String, detailed: String?): TransactionDto =
        apiClient.http.patch("${apiClient.baseUrl}/plaid/transactions/$transactionId/category") {
            contentType(ContentType.Application.Json)
            setBody(UpdateCategoryRequest(detailed))
        }.body()

    suspend fun getPortfolioHistory(): PortfolioHistoryResponse =
        apiClient.http.get("${apiClient.baseUrl}/plaid/investments/portfolio-history").body()

    suspend fun getSecurityPerformance(
        dashboardId: String? = null,
        accountId: String? = null,
    ): SecurityPerformanceResponse =
        apiClient.http.get("${apiClient.baseUrl}/plaid/investments/security-performance") {
            if (dashboardId != null) parameter("dashboard_id", dashboardId)
            if (accountId != null) parameter("account_id", accountId)
        }.body()

    suspend fun syncInvestmentPrices(source: String): PlaidPricesSyncResponse =
        apiClient.http.post("${apiClient.baseUrl}/plaid/investments/prices/sync") {
            parameter("source", source)
        }.body()

    suspend fun updateAccountNickname(accountId: String, nickname: String?): AccountDto =
        apiClient.http.patch("${apiClient.baseUrl}/accounts/$accountId") {
            contentType(ContentType.Application.Json)
            setBody(UpdateAccountNicknameRequest(nickname))
        }.body()
}
